/* ==========================================================================
   EpticLabs PDP — gedrag
   Galerij, staffelkorting, add-to-cart, sticky balk, voor/na-schuifbalk.
   Geen build-stap, geen afhankelijkheden. Praat met de cart-drawer van
   Horizon via Shopify.actions en valt terug op /cart als die er niet is.
   ========================================================================== */

(function () {
  'use strict';

  var money = function (cents, format) {
    var value = (cents / 100).toFixed(2);
    // Horizon levert het geldformaat aan als bv. "${{amount}}"
    if (format && format.indexOf('{{') !== -1) {
      return format.replace(/\{\{\s*(\w+)\s*\}\}/, value);
    }
    return '$' + value;
  };

  function init(root) {
    if (!root || root.dataset.epxReady === '1') return;
    root.dataset.epxReady = '1';

    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var variantId = root.dataset.variantId || '';

    /* ---------------- galerij ---------------- */
    var slides = root.querySelector('[data-epx-slides]');
    var dots = root.querySelectorAll('[data-epx-dot]');

    var thumbs = root.querySelector('[data-epx-thumbs]');

    if (slides && dots.length) {
      // Onthoud welke slide actief was. Zonder dit draaide syncDots bij élke
      // scrollframe de hele lus én startte hij de smooth-scroll van de
      // miniaturenstrook opnieuw op. Twee animaties die elkaar per frame
      // onderbraken — dat is wat er stroef aanvoelde.
      var laatsteIndex = -1;

      var huidigeIndex = function () {
        return Math.round(slides.scrollLeft / slides.clientWidth);
      };

      var syncDots = function () {
        var index = huidigeIndex();
        if (index === laatsteIndex) return;
        laatsteIndex = index;

        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-current', i === index ? 'true' : 'false');
        }

        // Twaalf miniaturen passen niet naast elkaar op een telefoon, dus de
        // actieve moet meebewegen. Alleen als de strook echt overloopt.
        //
        // Eerst alle maten uitlezen, dán pas scrollen. Lees je afwisselend uit
        // en schrijf je terug, dan moet de browser tussendoor de opmaak opnieuw
        // uitrekenen — Lighthouse noemt dat een forced reflow en het kostte hier
        // zestien milliseconde per beweging.
        if (thumbs) {
          var strookBreed = thumbs.scrollWidth;
          var vensterBreed = thumbs.clientWidth;
          var active = dots[index];
          if (active && strookBreed > vensterBreed + 4) {
            var actiefLinks = active.offsetLeft;
            var actiefBreed = active.clientWidth;
            var doel = actiefLinks - vensterBreed / 2 + actiefBreed / 2;
            var max = strookBreed - vensterBreed;
            thumbs.scrollTo({
              left: Math.max(0, Math.min(doel, max)),
              behavior: 'smooth',
            });
          }
        }
      };

      var wachtOpFrame = false;
      slides.addEventListener(
        'scroll',
        function () {
          if (wachtOpFrame) return;
          wachtOpFrame = true;
          window.requestAnimationFrame(function () {
            wachtOpFrame = false;
            syncDots();
          });
        },
        { passive: true }
      );

      for (var d = 0; d < dots.length; d++) {
        (function (button, index) {
          button.addEventListener('click', function () {
            // Naar de buren toe voelt een vloeiende beweging prettig. Verder
            // weg niet: dan animeert de browser langs elk tussenliggend
            // snappunt. Daarom springen we daar direct.
            var afstand = Math.abs(index - huidigeIndex());
            slides.scrollTo({
              left: index * slides.clientWidth,
              behavior: afstand > 1 ? 'auto' : 'smooth',
            });
            syncDots();
          });
        })(dots[d], d);
      }

      syncDots();
    }

    /* ---------------- staffelkorting ---------------- */
    var tiers = root.querySelectorAll('[data-epx-tier]');
    var priceEl = root.querySelector('[data-epx-price]');
    var compareEl = root.querySelector('[data-epx-compare]');
    var saveEl = root.querySelector('[data-epx-save]');
    var subEl = root.querySelector('[data-epx-atc-sub]');
    var stickyPrice = root.querySelector('[data-epx-sticky-price]');
    var stickyCompare = root.querySelector('[data-epx-sticky-compare]');
    var quantity = 1;

    function readTier(input) {
      return {
        qty: parseInt(input.dataset.qty, 10) || 1,
        total: parseInt(input.dataset.total, 10) || 0,
        compare: parseInt(input.dataset.compare, 10) || 0,
        save: input.dataset.save || '',
        note: input.dataset.note || '',
      };
    }

    function applyTier(input) {
      var t = readTier(input);
      quantity = t.qty;
      if (priceEl) priceEl.textContent = money(t.total, moneyFormat);
      if (compareEl) compareEl.textContent = t.compare ? money(t.compare, moneyFormat) : '';
      if (saveEl) saveEl.textContent = t.save;
      if (subEl) subEl.textContent = t.note;
      if (stickyPrice) stickyPrice.textContent = money(t.total, moneyFormat);
      if (stickyCompare) stickyCompare.textContent = t.compare ? money(t.compare, moneyFormat) : '';
    }

    for (var t2 = 0; t2 < tiers.length; t2++) {
      tiers[t2].addEventListener('change', function (event) {
        applyTier(event.currentTarget);
      });
      if (tiers[t2].checked) applyTier(tiers[t2]);
    }

    /* ---------------- add to cart ---------------- */
    var buttons = root.querySelectorAll('[data-epx-atc]');

    function setBusy(state, label) {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].disabled = state;
        if (label) {
          if (!buttons[i].dataset.label) buttons[i].dataset.label = buttons[i].textContent;
          buttons[i].textContent = label;
        } else if (buttons[i].dataset.label) {
          buttons[i].textContent = buttons[i].dataset.label;
        }
      }
    }

    function addToCart() {
      if (!variantId) {
        window.location.href = '/cart';
        return;
      }
      setBusy(true, 'Adding…');

      var actions = window.Shopify && window.Shopify.actions;

      if (actions && typeof actions.updateCart === 'function') {
        actions
          .updateCart(
            { lines: [{ merchandiseId: variantId, quantity: quantity }] },
            { event: { context: 'product' } }
          )
          .then(function () {
            setBusy(false);
            if (typeof actions.openCart === 'function') actions.openCart();
          })
          .catch(function () {
            setBusy(false);
            window.location.href = '/cart';
          });
        return;
      }

      // Terugval voor het geval Shopify.actions er niet is.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
      })
        .then(function () {
          window.location.href = '/cart';
        })
        .catch(function () {
          setBusy(false);
        });
    }

    for (var b = 0; b < buttons.length; b++) {
      buttons[b].addEventListener('click', addToCart);
    }

    /* ---------------- sticky balk ----------------
       Verschijnt pas als de échte koopknop bóven het scherm is verdwenen.
       De vorige versie keek alleen naar "niet in beeld", en dat is bij het
       laden óók waar — de knop staat dan nog ónder het scherm. Daardoor stond
       de balk er meteen, met de prijs erin, nog voordat iemand iets gelezen had.
       Hij verdwijnt weer zodra de laatste koopknop in beeld komt, anders staan
       er twee groene knoppen tegelijk op het scherm. */
    var sticky = root.querySelector('[data-epx-sticky]');
    var vasteKnoppen = [];
    for (var k = 0; k < buttons.length; k++) {
      if (!buttons[k].closest('[data-epx-sticky]')) vasteKnoppen.push(buttons[k]);
    }
    var eersteKnop = vasteKnoppen[0];
    var laatsteKnop = vasteKnoppen[vasteKnoppen.length - 1];

    if (sticky && eersteKnop && 'IntersectionObserver' in window) {
      var voorbijEersteKnop = false;
      var laatsteKnopInBeeld = false;

      var werkBalkBij = function () {
        sticky.classList.toggle('is-visible', voorbijEersteKnop && !laatsteKnopInBeeld);
      };

      new IntersectionObserver(
        function (entries) {
          var e = entries[0];
          voorbijEersteKnop = !e.isIntersecting && e.boundingClientRect.top < 0;
          werkBalkBij();
        },
        { threshold: 0 }
      ).observe(eersteKnop);

      if (laatsteKnop && laatsteKnop !== eersteKnop) {
        new IntersectionObserver(
          function (entries) {
            laatsteKnopInBeeld = entries[0].isIntersecting;
            werkBalkBij();
          },
          { threshold: 0.4 }
        ).observe(laatsteKnop);
      }
    } else if (sticky) {
      sticky.classList.add('is-visible');
    }

    /* ---------------- video's pas laden als je ze nadert ----------------
       Drie autoplay-video's van samen bijna vijf megabyte. Met een gewone src
       haalt de browser ze alle drie binnen vóór de eerste foto klaar is, en de
       meeste bezoekers scrollen nooit tot de tweede. De src hangt daarom in
       data-epx-video en wordt er hier pas aan gezet.

       De marges: verticaal drie schermen vooruit, horizontaal één. Dat tweede
       is voor de carrousel. Die video staat zes plekken naar rechts en is dus
       zes schermbreedtes ver; met één schermbreedte marge begint hij te laden
       zodra je bij het beeld ervoor bent, en niet bij het openen van de pagina.
       Zonder IntersectionObserver laden ze meteen — dan is de pagina traag,
       maar niet stuk. */
    var luieVideos = root.querySelectorAll('[data-epx-video]');
    if (luieVideos.length) {
      var start = function (video) {
        if (video.src) return;
        // Eerst het posterbeeld, dan de video. Het poster staat ook in een
        // data-attribuut: een gewoon poster-attribuut wordt meteen opgehaald,
        // ook met preload="none", en dat woog samen meer dan het eerste
        // carrouselbeeld.
        if (video.dataset.epxPoster) video.poster = video.dataset.epxPoster;
        video.src = video.dataset.epxVideo;
        var spelen = video.play();
        if (spelen && spelen.catch) spelen.catch(function () {});
      };

      if ('IntersectionObserver' in window) {
        var kijker = new IntersectionObserver(
          function (items) {
            for (var i = 0; i < items.length; i++) {
              if (!items[i].isIntersecting) continue;
              start(items[i].target);
              kijker.unobserve(items[i].target);
            }
          },
          { rootMargin: '300% 100%' }
        );
        for (var v = 0; v < luieVideos.length; v++) kijker.observe(luieVideos[v]);
      } else {
        for (var v2 = 0; v2 < luieVideos.length; v2++) start(luieVideos[v2]);
      }
    }

    /* ---------------- voor / na ---------------- */
    var ba = root.querySelector('[data-epx-ba]');
    if (ba) {
      var after = ba.querySelector('.epx__ba-after');
      var handle = ba.querySelector('.epx__ba-handle');
      var dragging = false;

      var move = function (clientX) {
        var rect = ba.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(2, Math.min(98, pct));
        if (after) after.style.width = pct + '%';
        if (handle) handle.style.left = pct + '%';
      };

      ba.addEventListener('pointerdown', function (e) {
        dragging = true;
        ba.setPointerCapture(e.pointerId);
        move(e.clientX);
      });
      ba.addEventListener('pointermove', function (e) {
        if (dragging) move(e.clientX);
      });
      ba.addEventListener('pointerup', function () {
        dragging = false;
      });
      ba.addEventListener('pointercancel', function () {
        dragging = false;
      });
    }
  }

  /* ---------------- reviewblok: hoogte van de iframe corrigeren ----------------
     De review-app zet zelf de hoogte van zijn iframe en meet daarbij zo'n
     dertig pixels te kort. Binnen dat document staat overflow:hidden, dus
     alles wat niet past wordt afgeknipt in plaats van scrollbaar.

     Gemeten gedrag: zet je de hoogte zelf goed, dan draait de app hem binnen
     een paar seconden terug. Met een timer meevechten levert dus geknipper op.
     Daarom zetten we min-height in plaats van height: in het CSS-boxmodel wint
     min-height altijd van height, en de app schrijft alleen height. Zo houdt
     hij zijn eigen waarde en klopt de doos toch.

     De iframe gebruikt srcdoc en is gelijk-origin, dus we mogen erin meten. */
  function fixReviewHoogte(root) {
    var wrap = root.querySelector('.epx__review-app');
    if (!wrap) return;

    var koppel = function (frame) {
      if (frame.dataset.epxHoogte === '1') return;
      frame.dataset.epxHoogte = '1';

      /* Groeien mag meteen, krimpen pas als het ook echt zo blijft.

         Bij de eerste klik op "view more" bouwt de widget zichzelf opnieuw op
         en is zijn inhoud een moment lang bijna nul. Volgden we die inzakking,
         dan werd de pagina korter en sprong hij omhoog — precies de klacht.
         Vandaar de vertraging op krimpen: een tijdelijke dip negeren we. */
      var krimpKlok = null;

      var hoogteNu = function () {
        var doc;
        try {
          doc = frame.contentDocument;
        } catch (e) {
          return 0; // andere origin: niets aan te doen
        }
        if (!doc || !doc.documentElement) return 0;
        return doc.documentElement.scrollHeight;
      };

      var meet = function () {
        var nodig = hoogteNu();
        if (!nodig) return;
        var huidig = parseFloat(frame.style.minHeight || 0);

        if (nodig > huidig + 1) {
          if (krimpKlok) {
            window.clearTimeout(krimpKlok);
            krimpKlok = null;
          }
          frame.style.minHeight = nodig + 'px';
          return;
        }

        if (nodig < huidig - 1) {
          if (krimpKlok) window.clearTimeout(krimpKlok);
          krimpKlok = window.setTimeout(function () {
            krimpKlok = null;
            var later = hoogteNu();
            if (later && later < parseFloat(frame.style.minHeight || 0) - 1) {
              frame.style.minHeight = later + 'px';
            }
          }, 1200);
        }
      };

      var gepland = false;
      var straks = function () {
        if (gepland) return;
        gepland = true;
        window.requestAnimationFrame(function () {
          gepland = false;
          meet();
        });
      };

      frame.addEventListener('load', straks);
      straks();

      /* Meekijken met de widget.

         Dit moet herhaald geprobeerd worden. Op het moment dat wij aanhaken is
         het document in de iframe vaak nog leeg — er is dan nog geen body om
         een observer op te zetten. Eén keer proberen bij het laden mislukt dus
         stilletjes, en daarna merken we een "load more" nooit meer op.

         Een ResizeObserver alleen is bovendien niet genoeg: die kijkt naar de
         doosmaat van het document, en die blijft gelijk als er alleen inhoud
         bijkomt. Bij "load more" groeit uitsluitend de scrollHeight. Een
         MutationObserver op de inhoud ziet dat wel. */
      /* Onthouden wélk document we hebben aangehaakt. Een srcdoc-iframe krijgt
         bij het opbouwen een nieuw Document-object; hingen we daarna nog aan
         het oude, dan vuurde er niets meer. Een simpele ja/nee-vlag was hier
         dus niet genoeg — we vergelijken het document zelf. */
      var gekoppeldDoc = null;

      var zorgVoorObservers = function () {
        var doc;
        try {
          doc = frame.contentDocument;
        } catch (e) {
          return; // andere origin: niets aan te doen
        }
        if (!doc || !doc.body) return;
        if (doc === gekoppeldDoc) return;

        gekoppeldDoc = doc;

        /* Aanhaken op documentElement en niet op body: de app bouwt de
           widget opnieuw op door de body te vervangen, en een observer op de
           oude body hangt daarna aan een losgekoppeld element en vuurt nooit
           meer. documentElement blijft wél bestaan. */
        /* Waarom de pagina bij de eerste "load more" omhoog sprong.

           Gemeten: de app roept na het laden focus() aan op het eerste nieuwe
           review-item. Focus haalt dat element in beeld, en omdat het in een
           iframe staat sleept de browser de hele pagina mee — omhoog, want het
           item staat boven de knop. Bij een tweede klik staat het al in beeld
           en gebeurt er niets, wat verklaart waarom alleen de eerste klik
           misging.

           preventScroll lost dat bij de bron op: de focus blijft werken voor
           toetsenbord en schermlezer, alleen het meescrollen vervalt. */
        var win = doc.defaultView;
        if (win && win.HTMLElement && !win.__epxFocusGepatcht) {
          win.__epxFocusGepatcht = true;
          var origFocus = win.HTMLElement.prototype.focus;
          win.HTMLElement.prototype.focus = function (opties) {
            var o = opties || {};
            o.preventScroll = true;
            try {
              return origFocus.call(this, o);
            } catch (e) {
              return origFocus.call(this);
            }
          };
        }

        /* De knop "Load more" is 105 bij 37 pixels — te klein om betrouwbaar
           te raken, zeker voor een doelgroep van 60 tot 75. Apple houdt 44
           pixels aan als ondergrens. De app biedt hier geen instelling voor,
           dus zetten we het in het document van de iframe zelf. */
        if (!doc.getElementById('epx-widget-stijl')) {
          var stijl = doc.createElement('style');
          stijl.id = 'epx-widget-stijl';
          stijl.textContent =
            '.scm-btn-load-more{min-height:48px!important;padding:13px 28px!important;' +
            'font-size:16px!important;line-height:1.2!important;border-radius:8px!important}' +
            /* De widget houdt 30px onder zijn laatste review vrij. Onze sectie
               zet daar zelf al ruimte onder, dus dat telde dubbel. */
            'body{padding-bottom:6px!important}';
          (doc.head || doc.documentElement).appendChild(stijl);
        }

        if (window.MutationObserver) {
          new MutationObserver(straks).observe(doc.documentElement, {
            childList: true,
            subtree: true,
          });
        }
        if (window.ResizeObserver) {
          new ResizeObserver(straks).observe(doc.documentElement);
          new ResizeObserver(straks).observe(doc.body);
        }
        /* Bij "load more" verspringt de pagina, want de widget scrollt zelf
           naar de nieuwe inhoud toe. Voor de bezoeker hoort er niets te
           bewegen: de knop staat onder in beeld en de nieuwe reviews horen
           daaronder te verschijnen. We onthouden waar hij stond en zetten hem
           terug zolang de widget nog aan het herschikken is. */
        doc.addEventListener('click', function (e) {
          var doel = e.target;
          var isLoadMore =
            doel &&
            doel.closest &&
            doel.closest('.scm-btn-load-more, .scm-pagination-load-more');

          if (!isLoadMore) {
            window.setTimeout(straks, 60);
            window.setTimeout(straks, 400);
            window.setTimeout(straks, 1200);
            return;
          }

          /* De widget herschikt zich ruim een seconde lang. In plaats van op
             een handvol momenten te corrigeren houden we de positie elk
             beeldje vast zolang dat duurt — anders zie je hem eerst wegspringen
             en daarna terugkomen. Scrollt de bezoeker in die tijd zelf, dan
             laten we meteen los: een grote verplaatsing is een bewuste veeg,
             geen herschikking. */
          var bewaard = window.pageYOffset;
          var begonnen = Date.now();
          var losgelaten = false;

          /* Meteen loslaten zodra de bezoeker zelf iets doet.

             Eerder liet ik pas los bij een verplaatsing van meer dan 1200px,
             en dat is verkeerd om: een veeg begint met vijftig pixels, dus
             werd iemand die wilde doorscrollen telkens teruggetrokken. Dat
             voelt als een pagina die vastloopt. Nu telt de intentie, niet de
             afstand: één aanraking, veeg of toets en we bemoeien ons nergens
             meer mee. */
          var laatLos = function () {
            losgelaten = true;
            for (var j = 0; j < signalen.length; j++) {
              window.removeEventListener(signalen[j], laatLos);
              if (doc) doc.removeEventListener(signalen[j], laatLos);
            }
          };
          var signalen = ['touchstart', 'touchmove', 'wheel', 'keydown', 'pointerdown'];
          for (var k = 0; k < signalen.length; k++) {
            window.addEventListener(signalen[k], laatLos, { passive: true });
            if (doc) doc.addEventListener(signalen[k], laatLos, { passive: true });
          }

          /* Alleen de scrollpositie bewaken per beeldje — dat is een uitlezing
             en hooguit een scrollTo, allebei goedkoop. De hoogte hermeten doen
             we hier nadrukkelijk NIET: dat leest scrollHeight in de iframe en
             schrijft min-height terug, en zestig keer per seconde een
             herberekening van de opmaak afdwingen laat de pagina vastlopen.
             De observers en de secondeklok houden de hoogte wel bij. */
          var vasthouden = function () {
            if (losgelaten) return;
            var afwijking = window.pageYOffset - bewaard;

            if (Math.abs(afwijking) > 600) {
              laatLos(); // te ver om nog een herschikking te zijn
              return;
            }
            if (Math.abs(afwijking) > 2) {
              window.scrollTo(0, bewaard);
            }

            if (Date.now() - begonnen < 700) {
              window.requestAnimationFrame(vasthouden);
            }
          };
          window.requestAnimationFrame(vasthouden);

          // hoogte bijwerken op een paar momenten, niet elk beeldje
          var momenten = [80, 300, 700, 1200, 2000];
          for (var i = 0; i < momenten.length; i++) {
            window.setTimeout(straks, momenten[i]);
          }
        });
      };

      zorgVoorObservers();

      // Vangnet voor de eerste seconden, waarin de widget nog aan het opbouwen is.
      /* Eerst een half jaar... nee: eerst dertig seconden dicht op de bal,
         daarna één keer per seconde blijven kijken. Dat laatste kost een
         enkele property-uitlezing en vangt alles op wat de observers missen —
         en na drie ronden debuggen weet ik dat die iets kunnen missen. */
      var teller = 0;
      var klok = window.setInterval(function () {
        zorgVoorObservers();
        straks();
        if (++teller === 60) {
          window.clearInterval(klok);
          window.setInterval(function () {
            zorgVoorObservers();
            straks();
          }, 1000);
        }
      }, 500);
    };

    var bestaande = wrap.querySelector('iframe');
    if (bestaande) koppel(bestaande);

    if (window.MutationObserver) {
      new MutationObserver(function () {
        var f = wrap.querySelector('iframe');
        if (f) koppel(f);
      }).observe(wrap, { childList: true, subtree: true });
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-epx-root]');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i]);
      fixReviewHoogte(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // De theme editor hangt secties opnieuw in de DOM.
  document.addEventListener('shopify:section:load', boot);
})();
